import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'

interface Props {
  tabs?: {value: string; label: string}[]
}

export function PickingListDrawerTabsList({tabs}: Props) {
  const {t} = useTranslate('common')
  return (
    <Tabs.List>
      <Tabs.Trigger value="orders">{t('picking_list.view_by_orders')}</Tabs.Trigger>
      <Tabs.Trigger value="aggregated">{t('picking_list.view_by_aggregated')}</Tabs.Trigger>
      {(tabs ?? []).map(tab => (
        <Tabs.Trigger key={tab.value} value={tab.value}>
          {tab.label}
        </Tabs.Trigger>
      ))}
    </Tabs.List>
  )
}
